import { render, staticRenderFns } from "./base-input-table.vue?vue&type=template&id=b71f42e0&scoped=true"
import script from "./base-input-table.ts?vue&type=script&lang=js&external"
export * from "./base-input-table.ts?vue&type=script&lang=js&external"
import style0 from "./base-input-table.vue?vue&type=style&index=0&id=b71f42e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71f42e0",
  null
  
)

export default component.exports